// 基于CommonMarkDown的markdown组件，，可以兼容处理一些特殊事件，目前支持换行符

import remarkBreaks from 'remark-breaks'

import type { FC } from 'react'

import { CommonMarkDown } from '@/components/CommonMarkDown'
import { useMarkdownTextProcessor } from '@/pages/tad.ai/ai-music-generator/_blocks/GeneratorForm/_hooks/useMarkdownTextProcessor'
export interface IMarkDownProps {
  content: string
  className?: string
}

export const MarkDown: FC<IMarkDownProps> = (props) => {
  const { content, className, ...rest } = props
  const escapedContent = useMarkdownTextProcessor(content)

  return (
    <div className={`[&>*:last-child]:mb-0 [&>*]:mb-5 ${className}`}>
      <CommonMarkDown remarkPlugins={[remarkBreaks]} {...rest}>
        {escapedContent}
      </CommonMarkDown>
    </div>
  )
}
